<template>
  <DataTable
    striped-rows
    lazy
    row-hover
    responsive-layout="scroll"
    breakpoint="300"
    class="p-datatable-sm"
    :row-class="checkRejected"
  >
    <Column
      field="licencePeriod"
      :header="$t('entity.lineId.licencePeriod')"
      :sortable="true"
      :show-filter-menu="false"
      :show-clear-button="false"
      style="min-width:200px"
    >
      <template #body="{data}">
        <span v-if="data.licencePeriod">
          {{
            $t(`entity.lineId.licencePeriods.${data.licencePeriod}`)
          }}
        </span>
      </template>
    </Column>

    <Column
      field="mainVenue"
      :header="$t('entity.lineId.mainVenue')"
      :sortable="true"
      :show-filter-menu="false"
      :show-clear-button="false"
      style="min-width:200px"
    >
      <template #body="{data}">
        <span v-if="data.mainVenue">
          {{ $i18n.locale === 'fr' ? data.mainVenue.frenchWording : data.mainVenue.englishWording }}
        </span>
      </template>
    </Column>

    <Column
      field="spectrumService"
      :header="$t('entity.lineId.spectrumService')"
      :sortable="true"
      :show-filter-menu="false"
      style="width:200px"
    >
      <template #body="{data}">
        <span v-if="data.spectrumService">
          {{ data.spectrumService }}
        </span>
      </template>
    </Column>


    <Column
      field="duplexHigh"
      :header="$t('entity.lineId.duplexHigh')"
      :sortable="true"
      :show-filter-menu="false"
      style="width:200px"
    >
      <template #body="{data}">
        <span v-if="data.duplexHigh">
          {{ data.duplexHigh }}
        </span>
      </template>
    </Column>

    <Column
      field="duplexLow"
      :header="$t('entity.lineId.duplexLow')"
      :sortable="true"
      :show-filter-menu="false"
      style="width:200px"
    >
      <template #body="{data}">
        <span v-if="data.duplexLow">
          {{ data.duplexLow }}
        </span>
      </template>
    </Column>

    <Column
      field="channelBandwidth"
      :header="$t('entity.lineId.channelBandwidth')"
      :sortable="true"
      :show-filter-menu="false"
      style="width:200px"
    >
      <template #body="{data}">
        <span v-if="data.channelBandwidth">
          {{ data.channelBandwidth }}
        </span>
      </template>
    </Column>

    <Column
      field="startDate"
      :header="$t('entity.lineId.startDate')"
      :sortable="true"
      :show-filter-menu="false"
      style="width:200px"
    >
      <template #body="{data}">
        <span>
          {{ formatDateTime(data.startDate) }}
        </span>
      </template>
    </Column>

    <Column
      field="endDate"
      :header="$t('entity.lineId.endDate')"
      :sortable="true"
      :show-filter-menu="false"
      style="width:200px"
    >
      <template #body="{data}">
        <span>
          {{ formatDateTime(data.endDate) }}
        </span>
      </template>
    </Column>
  </DataTable>
</template>

<script>

import DataTable from 'primevue/datatable';
import Column from 'primevue/column';

export default {
  name: 'ControlTableComponent',
  components: {Column, DataTable},
  methods: {
    formatDateTime(date) {
      return new Date(date).toLocaleDateString(this.$i18n.locale)
    },
    checkRejected(data){
      return data.status == 'REFUSED' ? 'table-rows-refused' : ''
    }
  }
}

</script>

